<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h2>Dashboard</h2>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState([
    ])
  },

  methods: {
    ...mapActions([
    ])
  }
}
</script>

<style scoped>
</style>
